import Header from "./Header";
import Footer from "./Footer";
import Loading from "./Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import collection from "../assets/icons/collections.svg";
import document from "../assets/icons/document.svg";
import multipleDocuments from "../assets/icons/multiple-documents.svg";
import home_page_abstract from "../assets/icons/home_page_abstract.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

import SearchInput from "./SearchInput";
import theme from "../styles/theme";

import "../styles/home.css";

import useHome from "../custom-hooks/useHome";

const HomeComponent = () => {
  const {
    loading,
    setLoading,
    collections,
    pages,
    documents,
    focus,
    setFocus,
    handleBrowseBooksClick,
    handleBrowsePeriodicalClick,
    navigate,
  } = useHome();

  return (
    <div>
      <Loading isLoading={loading}>
        <div className="main-container">
          <Header />
          <div className="heading">
            <p>
              <span className="sub-heading-1">Explore</span>{" "}
              <span className="sub-heading-2">Arab</span>
              <br />
              <span className="sub-heading-2">American</span>{" "}
              <span className="sub-heading-1">History</span>
            </p>
          </div>
          <SearchInput setLoading={setLoading} />
          <div className="row g-0">
            <div className="col or-image-div">
              <svg
                width="500"
                height="34"
                viewBox="0 0 600 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 16H600V18H0V16Z" fill="#6FB2C5" />
                <path d="M281 5H320V29H281V5Z" fill="#2D637A" />
                <path
                  d="M303 17L311.485 8.51472C316.172 3.82843 323.77 3.82843 328.456 8.51472L336.941 17L328.456 25.4853C323.77 30.1716 316.172 30.1716 311.485 25.4853L303 17Z"
                  fill="#2D637A"
                />
                <path
                  d="M300.5 34L292.015 25.5C287.328 20.8056 287.328 13.1944 292.015 8.5L300.5 0L308.985 8.5C313.672 13.1944 313.672 20.8056 308.985 25.5L300.5 34Z"
                  fill="#2D637A"
                />
                <path
                  d="M264 17L272.485 8.51472C277.172 3.82843 284.77 3.82843 289.456 8.51472L297.941 17L289.456 25.4853C284.77 30.1716 277.172 30.1716 272.485 25.4853L264 17Z"
                  fill="#2D637A"
                />
                <path
                  d="M294.578 23.1641C293.844 23.1641 293.185 23.0234 292.602 22.7422C292.018 22.4609 291.521 22.0651 291.109 21.5547C290.703 21.0391 290.391 20.4297 290.172 19.7266C289.958 19.0234 289.852 18.2474 289.852 17.3984V17.2344C289.852 16.3906 289.958 15.6172 290.172 14.9141C290.391 14.2057 290.703 13.5938 291.109 13.0781C291.521 12.5625 292.018 12.1641 292.602 11.8828C293.185 11.6016 293.844 11.4609 294.578 11.4609C295.354 11.4609 296.036 11.6016 296.625 11.8828C297.214 12.1641 297.706 12.5625 298.102 13.0781C298.503 13.5938 298.805 14.2057 299.008 14.9141C299.211 15.6172 299.312 16.3906 299.312 17.2344V17.3984C299.312 18.2474 299.211 19.0234 299.008 19.7266C298.805 20.4297 298.503 21.0391 298.102 21.5547C297.706 22.0651 297.214 22.4609 296.625 22.7422C296.036 23.0234 295.354 23.1641 294.578 23.1641ZM294.578 21.8828C295.333 21.8828 295.943 21.6953 296.406 21.3203C296.875 20.9453 297.219 20.4219 297.438 19.75C297.656 19.0729 297.766 18.2891 297.766 17.3984V17.2188C297.766 16.3333 297.654 15.5573 297.43 14.8906C297.211 14.2188 296.867 13.6953 296.398 13.3203C295.93 12.9401 295.323 12.75 294.578 12.75C293.896 12.75 293.318 12.9401 292.844 13.3203C292.37 13.7005 292.01 14.2266 291.766 14.8984C291.521 15.5651 291.398 16.3385 291.398 17.2188V17.3984C291.398 18.2839 291.521 19.0651 291.766 19.7422C292.01 20.4141 292.37 20.9401 292.844 21.3203C293.318 21.6953 293.896 21.8828 294.578 21.8828ZM300.5 23V22.0156L301.773 21.7969V12.8359L300.5 12.6172V11.6328H305.57C306.398 11.6328 307.096 11.7578 307.664 12.0078C308.237 12.2526 308.672 12.6094 308.969 13.0781C309.266 13.5469 309.414 14.1198 309.414 14.7969C309.414 15.4635 309.268 16.0234 308.977 16.4766C308.69 16.9297 308.281 17.2734 307.75 17.5078C307.219 17.737 306.589 17.8594 305.859 17.875L303.312 17.9219V21.7969L304.586 22.0156V23H300.5ZM308.008 23L305.477 17.3203L307.016 17.3047L309.117 21.8516L309.906 21.9922V23H308.008ZM303.312 16.7109H305.414C306.273 16.7109 306.898 16.5469 307.289 16.2188C307.68 15.8906 307.875 15.4115 307.875 14.7812C307.875 14.1823 307.688 13.7083 307.312 13.3594C306.938 13.0104 306.357 12.8359 305.57 12.8359H303.312V16.7109Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <div className="row g-0">
            <div className="col browse-collection-div">
              <p>
                <span className="browse-text-span">Browse our collection</span>
                <br />
                <span className="by-selecting-span">
                  by selecting a format to get started
                </span>{" "}
              </p>
            </div>
          </div>
          <div className="periodicals-books">
            <div className="periodicals">
              <button
                type="text"
                className="Placeholder newspaper-button"
                onClick={() => handleBrowsePeriodicalClick()}
              >
                Periodicals
                <FontAwesomeIcon
                  className="smaller-search-icon"
                  icon={faSearch}
                />
              </button>
            </div>
            <div className="books">
              <button
                type="text"
                className="Placeholder newspaper-button"
                onClick={() => handleBrowseBooksClick()}
              >
                {" "}
                Books
                <FontAwesomeIcon
                  className="smaller-search-icon"
                  icon={faSearch}
                />
              </button>

              <ReactTooltip id="book-tooltip" place="bottom" effect="solid" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm stats">
              <div className="icon-style">
                <img
                  src={document}
                  width="50px"
                  height="auto"
                  alt="subject stats logo"
                />
              </div>
              <div className="info-style">
                <p>
                  <div className="span-style-4382">
                    <CountUp start={focus ? 0 : null} end={pages}>
                      {({ countUpRef }) => (
                        <VisibilitySensor
                          onChange={(isVisible) => {
                            if (isVisible) {
                              setFocus(true);
                            }
                          }}
                        >
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                  </div>
                  <span className="span-style-below-4382">Pages</span>
                </p>
              </div>
            </div>
            <div class="col-sm stats">
              <div className="icon-style">
                <img
                  src={multipleDocuments}
                  width="50px"
                  height="auto"
                  alt="multiple documents logo"
                />
              </div>
              <div className="info-style">
                <p>
                  <div className="span-style-4382">
                    <CountUp start={focus ? 0 : null} end={documents}>
                      {({ countUpRef }) => (
                        <VisibilitySensor
                          onChange={(isVisible) => {
                            if (isVisible) {
                              setFocus(true);
                            }
                          }}
                        >
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                  </div>
                  <span className="span-style-below-4382">Documents</span>
                </p>
              </div>
            </div>
            <div class="col-sm stats">
              <div className="icon-style">
                <img
                  src={collection}
                  width="40px"
                  height="auto"
                  alt="collections logo"
                />
              </div>
              <div className="info-style">
                <p>
                  <div className="span-style-4382">
                    <CountUp start={focus ? 0 : null} end={collections}>
                      {({ countUpRef }) => (
                        <VisibilitySensor
                          onChange={(isVisible) => {
                            if (isVisible) {
                              setFocus(true);
                            }
                          }}
                        >
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                  </div>
                  <span className="span-style-below-4382">Collections</span>
                </p>
              </div>
            </div>
          </div>
          <div className="row g-0" style={{ marginTop: "5%" }}>
            <img
              width="90%"
              src={home_page_abstract}
              alt="home page abstract"
            />
          </div>
          <div style={{ backgroundColor: "#FFFFFF" }}>
            <div className="row g-0">
              <div className="search-browse-div">
                Search and browse Arab American books and <br /> newspapers
                published in North and South America from <br /> the late 1880s
                to the mid 1900s.
              </div>
            </div>
            <div className="row g-0">
              <a
                className="col"
                style={{
                  textAlign: "center",
                  marginBottom: "5%",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/learn-more")}
              >
                <span className="learn-more-span">Learn more&nbsp;&nbsp;</span>
                <FontAwesomeIcon
                  style={{ color: theme.colors.mainRed }}
                  icon={faArrowRight}
                />
              </a>
            </div>
          </div>

          <Footer />
        </div>
      </Loading>
    </div>
  );
};

export default HomeComponent;
